import { render, staticRenderFns } from "./TypeformTable.vue?vue&type=template&id=11dc54fd&scoped=true&"
import script from "./TypeformTable.vue?vue&type=script&lang=js&"
export * from "./TypeformTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11dc54fd",
  null
  
)

export default component.exports